import React, { Component } from "react";
import { Redirect } from 'react-router-dom'
import Auth from '../services/Auth';
import styled from "styled-components";
import { rgba } from "polished";
import { getVars } from "../global/utils";
import MainLayout from "../layouts/MainLayout";
import PageHeader from "../components/shared/PageHeader";
import Heading from "../components/text/Heading";
import Map from "../components/map/Map";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder } from "@fortawesome/free-solid-svg-icons";


const auth = new Auth();

const ProjectsContent = styled.div`
  .projects__layout {
    display: flex;
    flex-direction: column;
  }
  .projects__header {
    box-shadow: 0 8px 16px ${rgba(getVars("black", "_50"), 0.1)};
    position: relative;
    z-index: 1;
    h1{
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .projects__map {
    flex-grow: 1;
  }
`;

class Projects extends Component {
  render() {

    if (!auth.isAuthenticated()) {
      return <Redirect to="/login" />
    }

    if (!auth.isClw() ) {
      return <Redirect to="/" />;
    }

    return (
      <ProjectsContent>
        <MainLayout className="projects__layout">
          <PageHeader className="projects__header">
            <Heading level="heading1">
              <h1>
                <FontAwesomeIcon icon={faFolder} />
                CLW Loco
              </h1>
            </Heading>
          </PageHeader>
          <Map className="projects__map" />
        </MainLayout>
      </ProjectsContent>
    );
  }
}
export default Projects;



// WEBPACK FOOTER //
// ./src/pages/Projects.js